"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _path;
var KitchenDetails = function KitchenDetails(props) {
  return /*#__PURE__*/_react.default.createElement("svg", Object.assign({
    viewBox: "0 0 96 96"
  }, props), _path || (_path = /*#__PURE__*/_react.default.createElement("path", {
    d: "M57 7H17a2 2 0 0 0-2 2v78a2 2 0 0 0 2 2h63a2 2 0 0 0 2-2V29.173L64 10.177V34h-5a2 2 0 0 1-2-2V7zM10 0h53.14a2 2 0 0 1 1.452.624l23.86 25.181A2 2 0 0 1 89 27.181V94a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm49 34a2 2 0 0 1-2-2v-5h32.02v7H59zM25 52a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h39a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H25zm0 18a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h39a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H25zm0-36a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h19a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H25z",
    fill: "currentColor"
  })));
};
var _default = exports.default = KitchenDetails;